export type FlightCampaignStatus = NonNullable<App.FlightCampaign['status']>;

export const CAMPAIGN_STATUS_LABELS: Record<FlightCampaignStatus, string> = {
  draft: 'Draft',
  scheduled: 'Scheduled',
  live: 'Live',
  ended: 'Ended',
};

// Prefers the API status; otherwise derives it. A missing published_at (older API) is treated as published
export function getCampaignStatus(
  campaign: Pick<App.FlightCampaign, 'status' | 'published_at' | 'start_date' | 'end_date'>,
  now: Date = new Date(),
): FlightCampaignStatus {
  if (campaign.status) {
    return campaign.status;
  }
  if (campaign.published_at === null) {
    return 'draft';
  }
  const nowMs = now.getTime();
  if (campaign.end_date && new Date(campaign.end_date).getTime() < nowMs) {
    return 'ended';
  }
  const publishedMs = campaign.published_at ? new Date(campaign.published_at).getTime() : -Infinity;
  const startMs = campaign.start_date ? new Date(campaign.start_date).getTime() : -Infinity;
  if (publishedMs > nowMs || startMs > nowMs) {
    return 'scheduled';
  }
  return 'live';
}

export function campaignStatus(
  campaign: Pick<App.FlightCampaign, 'status' | 'published_at' | 'start_date' | 'end_date'>,
  now?: Date,
) {
  return CAMPAIGN_STATUS_LABELS[getCampaignStatus(campaign, now)];
}
